import { ENDPOINTS } from 'shared/constants/ENDPOINTS';
import { useAxios } from 'shared/hooks/useAxios';
import { ICompanyResponsePayload } from 'shared/interfaces/ICompany';
import {
  IAgencyAccessCodeParams,
  IAgencyResponsePayload,
  IGetAgenciesParams,
  IGetAgenciesResponse,
} from 'shared/interfaces/utils/IAgency';
import { GET_AGENCIES, GET_AGENCIES_PUBLIC } from 'shared/queries/agency.queries';
import { authToken } from 'shared/utils/authToken';

const { GET, POST } = useAxios();
const { getAuthToken } = authToken();
export const agencyDao = () => {
  const searchAgency = async (country: string, query: string) => {
    const response = await GET<IAgencyResponsePayload>({
      url: `${ENDPOINTS.AGENCY}`,
      params: {
        country,
        query,
      },
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });
    return response.data;
  };

  const validateAgencyCode = async (agencyCodeParams: IAgencyAccessCodeParams) => {
    if (agencyCodeParams.agency_access_code === '') return Promise.reject('Agency code is required');
    const response = await GET({
      url: `${ENDPOINTS.AGENCY_ACCESS_CODE}`,
      params: agencyCodeParams,
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });
    return response.data;
  };

  const getCompany = async (company_slug: string) => {
    if (!company_slug) return Promise.reject('Company slug is required');
    const response = await GET<ICompanyResponsePayload>({
      url: `${ENDPOINTS.COMPANY}?company_slug=${company_slug}`,
    });
    return response.data;
  };

  const getAgencies = async (payload: IGetAgenciesParams, isPublic?: boolean) => {
    //if payload.search is empty, it will return empty array on IGetAgenciesResponse
    if (!payload.search) return Promise.reject('Search is required');

    const response = await POST<IGetAgenciesResponse>({
      url: ENDPOINTS.GRAPHQL,
      data: {
        query: isPublic ? GET_AGENCIES_PUBLIC : GET_AGENCIES,
        variables: { ...payload },
      },
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });
    return response.data;
  };

  return {
    getAgencies,
    getCompany,
    searchAgency,
    validateAgencyCode,
  };
};
